import React from "react";
import { EditIcon } from "../Icons";
import { displayDateUS } from "../utils/dateUtils";
import toast from "react-hot-toast";
import {
  INACTIVE_TO_ACTIVE_REQUIRES_SUPPORT_MESSAGE,
  isEmployeeInactiveStatus,
} from "../constants/employeeStatus";
import { EMPLOYEE_ROLE_CHIP } from "../components/Employees/employeeTheme";

export const getEmployeeColumns = ({
  tagColors,
  editing,
  setEditing,
  handleCellChange,
  setUsers,
  navigate,
  isAdmin,
}) => [
  { header: "First Name", accessor: "firstName", sortable: true },
  { header: "Last Name", accessor: "lastName", sortable: true },
  {
    header: "Hire Date",
    accessor: "hireDate",
    sortable: true,
    render: (row) => displayDateUS(row.hireDate),
  },
  { header: "Email", accessor: "email", sortable: true },
  {
    header: "Work Mode",
    accessor: "workMode",
    sortable: true,
    render: (u) => (
      <span className="text-sm text-slate-600 font-medium">
        {u.workMode || "WFO"}
      </span>
    ),
  },
  {
    header: "Position",
    accessor: "position",
    sortable: true,
    render: (row) => (
      <span
        className={`inline-flex items-center h-5 px-1.5 rounded-md text-[10px] font-semibold uppercase tracking-wide ${
          tagColors?.[row.position] || EMPLOYEE_ROLE_CHIP
        }`}
      >
        {row.position || "N/A"}
      </span>
    ),
  },
  {
    header: "Status",
    accessor: "status",
    sortable: true,
    render: (u) => {
      const inactive = isEmployeeInactiveStatus(u.status);
      return (
        <div
          className="cursor-pointer"
          onDoubleClick={() => {
            if (inactive) {
              toast.error(INACTIVE_TO_ACTIVE_REQUIRES_SUPPORT_MESSAGE);
              return;
            }
            setEditing({ id: u._id, field: "status" });
          }}
          title={
            inactive
              ? "Inactive employees cannot be reactivated here — contact customer support"
              : "Double-click to change status"
          }
        >
          {editing.id === u._id && editing.field === "status" ? (
            <select
              value={(u.status || "active").toLowerCase()}
              autoFocus
              onBlur={(e) => handleCellChange(u._id, "status", e.target.value)}
              onChange={(e) => {
                const next = e.target.value;
                if (inactive && next === "active") {
                  toast.error(INACTIVE_TO_ACTIVE_REQUIRES_SUPPORT_MESSAGE);
                  return;
                }
                setUsers((prev) =>
                  prev.map((user) =>
                    user._id === u._id ? { ...user, status: next } : user,
                  ),
                );
              }}
              className="border border-indigo-200 p-1 w-full rounded-md text-sm focus:border-indigo-300 focus:ring-2 focus:ring-indigo-100 outline-none"
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          ) : (
            <span
              className={`inline-flex items-center h-5 px-1.5 rounded-md border text-[10px] font-semibold ${
                (u.status || "active").toLowerCase() === "active"
                  ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                  : "bg-slate-50 text-slate-600 border-slate-200"
              }`}
            >
              {(u.status || "active").replace(/^./, (str) => str.toUpperCase())}
            </span>
          )}
        </div>
      );
    },
  },
  {
    header: "Actions",
    accessor: "actions",
    render: (u) => (
      <div className="flex gap-2">
        <button
          type="button"
          className="bg-indigo-50 hover:bg-indigo-100 text-indigo-600 p-2 rounded-lg transition-colors group border border-indigo-100"
          onClick={() =>
            navigate(`/employees/update/${u.id}`, {
              state: { hireDate: u.hireDate },
            })
          }
          title="Update details"
        >
          <EditIcon
            size={18}
            className="group-hover:scale-110 transition-transform"
          />
        </button>
      </div>
    ),
  },
];
